import { toast } from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { getServerErrorMessage } from "utils/showMutationError";

/**
 * Mark one document reviewed, recording the logged-in staff member as the reviewer
 * (KIN-2114). Both Documents pages and the preview call this one hook.
 *
 * It still posts the whole document back to `/document`, as the two copies of this handler
 * did before. KIN-2113 is to give review its own endpoint; when it lands, only `mutationFn`
 * here changes.
 */
export const useMarkDocumentReviewed = ({ tenant, reviewerStaffId, onSuccess }) =>
  useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async (document) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenant}/document`, {
        ...document,
        status: "REVIEWED",
        reviewedById: reviewerStaffId,
      });

      return response.data;
    },
    onSuccess: () => {
      toast.success("Document marked as reviewed");
      onSuccess?.();
    },
    onError: (error) => {
      console.error(error);
      toast.error(
        getServerErrorMessage(error, "The document could not be marked as reviewed.")
      );
    },
  });
